import { useMemo } from "react"
import { createLabelColumn, createMetricColumns, createColumnGroupingModel } from "../helpers"
import { useOrderedMetricMetadata } from "./use-ordered-metric-metadata"

export const useColumnDefinitions = (props) => {
  const { metricMetadata, metricCategories, sortMetricId, sortDirection, groupingEnabled, savedCustomColumnOrder, columnOrder, data } = props

  // Reorder metricMetadata based on column order mode (default, custom, magnitude-based)
  const orderedMetricMetadata = useOrderedMetricMetadata(metricMetadata, columnOrder, data, savedCustomColumnOrder)

  const columnGroupingModel = useMemo(() => {
    return createColumnGroupingModel({ metricMetadata: orderedMetricMetadata, metricCategories, sortMetricId, sortDirection, groupingEnabled })
  }, [orderedMetricMetadata, metricCategories, sortMetricId, sortDirection, groupingEnabled])

  const groupEndFieldSet = useMemo(() => {
    const set = new Set()
    if (!columnGroupingModel) return set
    columnGroupingModel.forEach((item) => {
      if (item.children && Array.isArray(item.children) && item.children.length > 0) {
        const lastChild = item.children[item.children.length - 1]
        if (lastChild?.field) {
          set.add(lastChild.field)
        }
      }
    })
    return set
  }, [columnGroupingModel])

  const columns = useMemo(() => {
    const labelColumn = createLabelColumn(props)
    const metricColumns = createMetricColumns({ ...props, metricMetadata: orderedMetricMetadata, groupEndFieldSet })
    return [labelColumn, ...metricColumns]
  }, [props, orderedMetricMetadata, groupEndFieldSet])

  return {
    columns,
    columnGroupingModel,
  }
}
